import * as React from "react";
import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * TINA Spinner — Lucide Loader2 with size + tone presets.
 *
 * For loading states longer than 300ms. For tables/cards specifically,
 * prefer a skeleton screen over a spinner (per MASTER.md).
 */
type SpinnerSize = "sm" | "md" | "lg";

interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  size?: SpinnerSize;
  /** Accessible name. Defaults to "Loading…" — translate at the call site. */
  label?: string;
}

const sizeMap: Record<SpinnerSize, string> = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-8 w-8",
};

function Spinner({ size = "md", label = "Loading…", className, ...props }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      className={cn("animate-spin text-primary", sizeMap[size], className)}
      {...props}
    />
  );
}

export { Spinner };
